import './style.scss';
import React, { useRef, useState } from 'react';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';
import clsx from 'clsx';
import CardItemsCarousel from './CardItemsCarousel';
import CardItems from './CardItems';
import { RichText, Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import CustomCarouselControls from '../Shared/components/CustomCarouselControls';
const AwardsListing = (props) => {

  const { fields, params, sitecoreContext } = props;
  const { items } = fields;
  const [nextDisabled, setNextDisabled] = useState(false);
  const [prevDisabled, setPrevDisabled] = useState(true);
  const swiperRef = useRef();

  const shouldRenderList = Array?.isArray(items) && items?.length > 0;
  if (!shouldRenderList) return null;

  const rightArrow = '/-/media/Project/FAB2/Fab2/data/media/svgs/gallery/icon-arrow-right';
  const leftArrow = '/-/media/Project/FAB2/Fab2/data/media/svgs/gallery/icon-arrow-left';

  const _text = fields?.text;
  const _heading = fields?.heading;
  const _year = fields?.year;
  const shouldRenderTitle = !!_heading && _heading?.value !== '';
  const shouldRenderDescription = !!_text && _text?.value !== '';
  const shouldRenderYear = !!_year?.value && _year !== '';


  const isCarousel = params?.carouselMode === '1';
  const isCarouselOnMobile = items?.length > 3;
  const onlyThree = items?.length <= 3;
  return (
    <div
      className={clsx(
        'AwardsListingSection',
        isCarousel && 'carousel-layout',
        !isCarousel && 'grid-layout',
        'add-margins',
        props?.params?.Styles
      )}
    >
      <div className="content">
        <div
          className={clsx(
            'award-listing',
            isCarouselOnMobile ? 'changeToCarouselOnMobile' : 'notCarouselOnMobile',
            onlyThree ? 'onlyThree' : ''
          )}
        >
          {!isCarousel && (
            <>
              {/* if isCarouselOnMobile only show the grid-desktop on desktop and carousel on mobile
              bcz three items or less we dont have swiper */}
              <div className={clsx('grid-desktop', isCarouselOnMobile ? 'desktop' : '')}>
                {(shouldRenderTitle || shouldRenderDescription) && (
                  <div className="data-wrap">
                    {shouldRenderTitle && (
                      <div className="item-title">
                        <Text field={_heading} />
                      </div>
                    )}
                    {shouldRenderDescription && (
                      <RichText className="item-description" field={_text} />
                    )}
                    {shouldRenderYear && (
                      <RichText className="card-item-description" field={_year} />
                    )}
                  </div>
                )}

                <div className="card-grid-view flex-it flex-wrap">
                  <CardItems items={fields?.items} />
                </div>
              </div>
              {/* show slider on mobile instead of grid if we have more than three items */}
              {isCarouselOnMobile && (
                <div className="grid-to-swiper mobile">
                  <div className={clsx('swiper-wrap')}>
                    {(shouldRenderTitle || shouldRenderDescription) && (
                      <div className="data-wrap">
                        {shouldRenderTitle && (
                          <div className="item-title">
                            <Text field={_heading} />
                          </div>
                        )}
                        {shouldRenderDescription && (
                          <RichText className="item-description" field={_text} />
                        )}
                        {shouldRenderYear && (
                          <RichText className="card-item-description" field={_year} />
                        )}
                      </div>
                    )}
                    <CardItemsCarousel
                      items={fields?.items}
                      language={sitecoreContext.language}
                      setPrevDisabled={setPrevDisabled}
                      setNextDisabled={setNextDisabled}
                      swiperRef={swiperRef}
                    />
                  </div>
                </div>
              )}
            </>
          )}
          {isCarousel && (
            <div className={clsx('swiper-wrap')}>
              {(shouldRenderTitle || shouldRenderDescription) && (
                <div className="data-wrap">
                  {shouldRenderTitle && (
                    <div className="item-title">
                      <Text field={_heading} />
                    </div>
                  )}
                  {shouldRenderDescription && (
                    <RichText className="item-description" field={_text} />
                  )}
                  {shouldRenderYear && <RichText className="card-item-description" field={_year} />}
                </div>
              )}
              <CustomCarouselControls
                classname="navigation-custom"
                rightArrow={rightArrow}
                leftArrow={leftArrow}
                totalItems={fields?.items?.length}
                nextDisabled={nextDisabled}
                prevDisabled={prevDisabled}
                swiperRef={swiperRef}
              />
              <CardItemsCarousel
                items={fields?.items}
                language={sitecoreContext?.language}
                setPrevDisabled={setPrevDisabled}
                setNextDisabled={setNextDisabled}
                swiperRef={swiperRef}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default withSitecoreContext()(AwardsListing);
